import React from 'react';

/** Shared page title block with responsive text sizes */
function PageHero({ eyebrow, title, subtitle, align = 'center' }) {
  const alignClass = align === 'left' ? 'text-left' : 'text-center';
  return (
    <div className={`mx-auto max-w-3xl px-4 py-8 sm:py-10 md:py-12 ${alignClass}`}>
      {eyebrow ? (
        <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#0075ca] sm:text-xs">
          {eyebrow}
        </p>
      ) : null}
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl md:text-4xl lg:text-[2.75rem] lg:leading-tight">
        {title}
      </h1>
      {subtitle ? (
        <p className="mt-3 text-sm leading-relaxed text-slate-500 sm:text-base md:text-lg">
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}

export default PageHero;
